import { FC, PropsWithChildren } from "react";
import TableContainer from "@mui/material/TableContainer";
import styled from "@emotion/styled";
import TableCell, { TableCellProps } from "@mui/material/TableCell";
import { tableCellClasses } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }: any) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.text.secondary,
    fontSize: "14px",
    lineHeight: "22px",
    fontWeight: "600",
  },
}));

const StyledTableContainer: FC<PropsWithChildren> & {
  StyledTableCell: FC<TableCellProps>;
} = ({ children }) => {
  return (
    <TableContainer
      sx={{
        border: "solid 1px",
        borderColor: "divider",
        borderRadius: "4px",
        borderBottom: "none",
      }}
    >
      {children}
    </TableContainer>
  );
};

StyledTableContainer.StyledTableCell = StyledTableCell;

export default StyledTableContainer;
